import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  errorMessage: {
    id: 'proforma-form-system.add-form.ui.error-state.error-message',
    defaultMessage: 'We’re unable to load forms. Refresh this page and try again.',
    description: 'Text for the error state when there is an error in form preview.'
  }
});